<div class="space-y-3">
  <button
    type="button"
    (click)="signIn('google')"
    [disabled]="pending() !== null"
    class="w-full flex items-center justify-center gap-3 px-6 py-3 bg-white border-2 border-border-subtle text-flap-black rounded-lg font-semibold hover:bg-bg-secondary hover:border-flap-black focus:border-signal-orange outline-none transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
  >
    <svg class="w-5 h-5 shrink-0" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path
        d="M12.545 10.239v3.821h5.445c-.712 2.315-2.647 3.972-5.445 3.972a6.033 6.033 0 1 1 0-12.064c1.498 0 2.866.549 3.921 1.453l2.814-2.814A9.969 9.969 0 0 0 12.545 2C7.021 2 2.543 6.477 2.543 12s4.478 10 10.002 10c8.396 0 10.249-7.85 9.426-11.748l-9.426-.013z"
      />
    </svg>
    {{ pending() === 'google' ? 'Redirecting…' : 'Continue with Google' }}
  </button>

  <button
    type="button"
    (click)="signIn('github')"
    [disabled]="pending() !== null"
    class="w-full flex items-center justify-center gap-3 px-6 py-3 bg-white border-2 border-border-subtle text-flap-black rounded-lg font-semibold hover:bg-bg-secondary hover:border-flap-black focus:border-signal-orange outline-none transition-colors disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer"
  >
    <svg class="w-5 h-5 shrink-0" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path
        d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23a11.5 11.5 0 0 1 3-.405c1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
      />
    </svg>
    {{ pending() === 'github' ? 'Redirecting…' : 'Continue with GitHub' }}
  </button>
</div>

<div class="flex items-center gap-4 my-6" aria-hidden="true">
  <span class="h-0.5 flex-1 bg-border-subtle"></span>
  <span class="text-xs font-semibold uppercase tracking-wider text-rail-gray">or</span>
  <span class="h-0.5 flex-1 bg-border-subtle"></span>
</div>
